// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.tomi",
    name: "tomi Wallet",
    homepage: "https://tomi.com/wallet",
    image_id: "ebc78bed-8771-4745-0fbd-f846cc107100",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/tomipay-digital-payment-system/id1643501440",
        android: "https://play.google.com/store/apps/details?id=com.tomiapp.production",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/tomipay/feoojlbclclaoifjiedeeenhldlenopl",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "tomiwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map